import * as React from 'react';
import { connect } from 'react-redux';
import { loginUser } from '../../src/actions/auth';
import { Button, Card, Flex, Form, Image, Input, notification, Space } from 'antd';

interface Props {
  isAuthenticated: boolean;
  dispatch: any;
}

interface State {
  email: string;
  password: string;
  isLoging: boolean;
}

class Login extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      isLoging: false,
    };
  }
  openNotificationWithIcon = (type, msg, disc) => {
    notification[type]({
      message: msg,
      description: disc,
    });
  };

  getIPAddress = async () => {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  }

  getLocation = (): Promise<{ latitude: number; longitude: number }> => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          },
          (error) => reject(error)
        );
      } else {
        reject(new Error('Geolocation is not supported by this browser.'));
      }
    });
  }

  getBrowserDetails = () => {
    const userAgent = navigator.userAgent;
    return {
      platform: /Mobi|Android|iPhone/i.test(userAgent) ? 'mobile' : 'web',
      userAgent,
    };
  }


  render() {
    if (!this.props.isAuthenticated) {
      return (
        <>
          <Flex justify="center" align='center' style={{ height: '60vh' }}>
            <Card style={{ width: 300, height: 300, alignItems: 'center' }}>
              <Form
                layout='vertical'
                onFinish={async (values) => {
                  this.setState({ isLoging: true });
                  const ipAddress = await this.getIPAddress();
                  const location = await this.getLocation();
                  const browserDetails = this.getBrowserDetails();

                  this.props.dispatch(loginUser({
                    username: values.username,
                    password: values.password,
                    ipAddress,
                    latitude: location.latitude,
                    longitude: location.longitude,
                    platform: browserDetails.platform,
                    userAgent: browserDetails.userAgent,
                  }, (response) => {
                    if (response.code === 200) {
                      const msg = 'Success';
                      const disc = 'Login Success';
                      this.setState({ isLoging: false });
                      this.openNotificationWithIcon('success', msg, disc);
                      window.location.replace('/');
                    } else {
                      const msg = 'Login Fail';
                      const disc =
                        'Please enter correct emailId and Password';
                      this.openNotificationWithIcon('error', msg, disc);
                      this.setState({ isLoging: false });
                    }
                  }));
                }}
              >
                <Space direction='vertical' style={{ width: '100%' }}>
                  <Image src={require('./../assets/logo/7851308.png')} preview={false} />

                  <Space direction='vertical' style={{ width: '100%' }}>
                    <Form.Item
                      name="username"
                      label="Username / Email Id"
                      rules={[{ required: true, message: 'Please input your username!' }]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      label="Password"
                      rules={[{ required: true, message: 'Please input your password!' }]}
                    >
                      <Input.Password />
                    </Form.Item>
                  </Space>
                  <Space direction='vertical' style={{ width: '100%' }} align='center'>
                    <Button type='primary' style={{ width: '100%' }} htmlType='submit' loading={this.state.isLoging}>Login</Button>
                  </Space>
                </Space>
              </Form>
            </Card>
          </Flex >
        </>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(Login);
